module.exports = {"name":"boardInvitees","meta":{"description":"Experiment for appcues survey to invitees and intro + orient invitees","link":""},"audiences":["englishAndNewAndNoTeams"],"defaults":{"enabled":false},"audienceSettings":{"startDate":"2019-03-01"},"defaultWeight":1,"experimentAllocation":0,"experimentVersion":"v1","variations":[{"name":"survey","weight":0.5,"values":{"enabled":true}},{"name":"_____","weight":0.25,"values":{"enabled":true}},{"name":"_____","weight":0.25,"values":{"enabled":true}}],"autoTrack":false}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/boardInvitees.json
// module id = drJR
// module chunks = 13